import { render, staticRenderFns } from "./LoanOfficerSettings.vue?vue&type=template&id=f94ff4ba"
import script from "./LoanOfficerSettings.vue?vue&type=script&lang=js"
export * from "./LoanOfficerSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports